<template>
  <div>
    <div class="content w-1200">
      <div class="top-box">
        <el-form label-position="left" :model="form" label-width="70px">
          <el-row>
            <el-col :span="6" :offset="1">
              <el-form-item label="cas" prop="cas_no">
                <el-input v-model="form.cas_no" placeholder="请输入cas号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-form-item label="订单编号" prop="order_on">
                <el-input v-model="form.orderno" placeholder="请输入订单编号"/>
              </el-form-item>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-form-item label="发布时间" style="{width:100%;overflow: hidden}">
                <el-date-picker value-format="yyyy-MM-dd" v-model="form.created_at" type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :offset="12" :span="10" class="flex-end padding-top-10">
              <gradient-button background="#0C60E6" @hit="handleSearch">搜索</gradient-button>
              <gradient-button @hit="handleReset" color="#5F616C" border="1px solid #5F616C"
                               background="transparent">刷新
              </gradient-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="ter-bars">
        <div class="left-title hit-cursor">
          <div v-for="item in terbars" :key="item.value" :class="[
              'ter-bar-item',
              activeTarBar === item.value ? 'active' : '',
            ]" @click="handleTarBar(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="right-add">
          <gradient-button background="#0C60E6" @hit="handleAdd">新增产品</gradient-button>
        </div>
      </div>
      <div class="fotter-box">
        <div class="teble-box" v-loading="loading">
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{
              backgroundColor: '#F6F6F8',
              color: '#00112B',
            }">
            <el-table-column type="index" width="50" label="序号" fixed="left" align="center">
            </el-table-column>
            <el-table-column prop="orderno" width="180" label="订单编号" align="center"/>
            <el-table-column prop="cas_no" width="120" label="CAS号" align="center"/>
            <el-table-column prop="product_name" width="120" label="产品名称" align="center"/>
            <el-table-column prop="total_price" label="价格" width="100" align="center">
              <template slot-scope="scope">
                {{ (scope.row.total_price - scope.row.service).toFixed(2) }}元
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 1 && scope.row.pay_submit !== 1" type="info">待付款</el-tag>
                <el-tag v-if="scope.row.status === 1 && scope.row.pay_submit === 1" type="info">等待确认收款</el-tag>
                <el-tag v-if="scope.row.status === 2" type="">待打款</el-tag>
                <el-tag v-if="scope.row.status == 3" type="warning">待发货</el-tag>
                <el-tag v-if="scope.row.status == 4" type="danger">待收货</el-tag>
                <el-tag v-if="scope.row.status == 5" type="success">交易完成</el-tag>
                <el-tag v-if="scope.row.status == -1" type="danger">已取消</el-tag>

              </template>
            </el-table-column>
            <el-table-column prop="cas" label="合同" width="150" align="center">
              <template slot-scope="scope">
                <a class="color-blue" v-if="scope.row.sell_contract" :href="scope.row.sell_contract"
                   target="_blank">点击查看合同</a>
                <a class="color-blue" v-if="!scope.row.sell_contract&&scope.row.is_apply_contract==1 "
                   :href="scope.row.sell_contract"
                   target="_blank">等待上传</a>
                <el-button align="center" type="text" v-if="
                    scope.row.status >= 2 && scope.row.is_apply_contract == 2
                  " size="small" @click="handleContract(scope.row)">申请合同
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="sell_contract" label="发货单" width="150" align="center">
              <template slot-scope="scope">
                <a class="color-blue" :href="linkPath + '/test-label?id=' + scope.row.id"
                   target="_blank">点击打印发货单</a>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" width="160" label="发布时间" align="center"/>
            <el-table-column prop="created_at" width="160" label="联系客户" align="center"
                             v-if="is_vip&&userInfo.member_type==2">
              <template slot-scope="scope">
                <template>
                  <div>
                    {{ scope.row.address.name }}
                  </div>
                  <div>{{ scope.row.address.phone }} <span class="color-blue"
                                                           @click="copyText(scope.row.address.phone)">
                  <i class="el-icon-copy-document"></i>
                </span></div>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="yewu" width="160" label="联系业务" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.yewu">
                  <div>{{ scope.row.yewu.name }}</div>
                  <div>{{ scope.row.yewu.mobile }} <span class="color-blue" @click="copyText(scope.row.yewu.mobile)">
                  <i class="el-icon-copy-document"></i>
                </span></div>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="getAddress" label="收货地址" width="300" align="center"
                             v-if="is_vip&&userInfo.member_type==2">
              <template slot-scope="scope">
                {{ scope.row.address.province }}{{
                  scope.row.address.city
                }}{{
                  scope.row.address.district
                }}{{ scope.row.address.address }}
              </template>
            </el-table-column>

            <el-table-column prop="operation" label="操作" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDetail(scope.row)">查看</el-button>
                <el-button type="text" size="small" v-if="scope.row.status == 3"
                           @click="handleDelivery(scope.row)">去发货
                </el-button>
                <el-button type="text" v-if="
                    scope.row.status >= 2 && scope.row.is_apply_contract == 2
                  " size="small" @click="handleContract(scope.row)">申请合同
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" background
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               title="销售订单详情" :visible.sync="detailDialogVisible" :before-close="handleCloseDetail">
      <div class="detail-content">
        <div class="detail-left" v-if="detail">
          <!-- <img :src="detail.product.image" alt="" v-if="detail.product.image">
       -->
          <div class="detail-right">
            <table class="custom-table" border="1">
              <tr>
                <td>订单状态</td>
                <td>
                  <el-tag v-if="detail.status === 1 && detail.pay_submit !== 1" type="info">待付款</el-tag>
                  <el-tag v-if="detail.status === 1 && detail.pay_submit === 1" type="info">等待确认收款</el-tag>
                  <el-tag v-if="detail.status == 2" type="warning">待打款</el-tag>
                  <el-tag v-if="detail.status === 3" type="">待发货</el-tag>
                  <el-tag v-if="detail.status == 4" type="danger">待收货</el-tag>
                  <el-tag v-if="detail.status == 5" type="success">交易完成</el-tag>
                </td>
                <td>订单编号</td>
                <td>{{ detail.orderno || "--" }}</td>
              </tr>
              <tr>

                <td>产品名称</td>
                <td>{{ detail.product_name || "--" }}</td>
                <td>CAS编号</td>
                <td>{{ detail.cas_no || "--" }}</td>
              </tr>
              <tr>
                <td>产品数量</td>
                <td>{{ detail.cart_num || 1 }}</td>
                <td>订单价格</td>
                <td>{{ (detail.total_price - detail.service).toFixed(2) || "--" }}元</td>
              </tr>
              <tr>
                <td>规格</td>
                <td>{{ detail.unit || "--" }}</td>
                <td>纯度</td>
                <td>{{ detail.purity || "--" }}%</td>
              </tr>
              <tr>
                <td>下单时间</td>
                <td>{{ detail.created_at || "--" }}</td>
                <td>支付方式</td>
                <td>
                  <div v-if=" detail.pay_type === 'wechat_jsapi'">微信支付</div>
                  <div v-if=" detail.pay_type === 'wechat_native'">扫码支付</div>
                  <div v-if=" detail.pay_type === 'alipay'">支付宝</div>
                  <div v-if=" detail.pay_type === 'remit_alipay'">直接汇款-支付宝</div>
                  <div v-if=" detail.pay_type === 'remit_bank'">直接汇款-银行转账</div>
                  <div v-if=" !detail.pay_type">未支付</div>
                </td>
              </tr>
              <tr v-if="detail.status>=4">
                <td>快递公司</td>
                <td>{{ detail.express_company || "--" }}
                  <el-button
                      type="text"
                      size="small"
                      @click="viewExpressInfo"
                  >
                    查看快递
                  </el-button>
                </td>
                <td>快递单号</td>
                <td>
                  {{ detail.express_order }}
                </td>
              </tr>
              <template v-if="detail.address && is_vip&&userInfo.member_type==2">
                <tr>
                  <td>收货人姓名</td>
                  <td>{{ detail.address.name }}</td>
                  <td>联系方式</td>
                  <td>
                    {{ detail.address.phone }}
                  </td>
                </tr>
                <tr>
                  <td>收货地址</td>
                  <td colspan="3">
                    {{ detail.address.province }} {{ detail.address.city }}
                    {{ detail.address.area }} {{ detail.address.address }}
                  </td>
                </tr>
              </template>
              <tr v-if="userInfo.member_type==2&&is_vip">
                <td>备注</td>
                <td colspan="3">
                  {{ detail.remark || "--" }}
                </td>
              </tr>
              <tr v-if="detail.status === 3">
                <td>打款凭证</td>
                <td colspan="3">
                  <img class="image-pay" :src="detail.pay_supplier" @click="doLook(detail.pay_supplier)">
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 联系客服 -->
    <el-dialog :close-on-press-escape="true" :close-on-click-modal="false" :modal-append-to-body="false"
               title="联系客服"
               :modal="true" top="20vh" :visible.sync="dialogVisiblecos" width="30%" :before-close="handleClose">
        <span class="dialog-content" @click="copyText(dialogContent)">{{ dialogContent }} <i
            class="el-icon-copy-document"></i>
        </span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblecos = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisiblecos = false">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 新增产品弹窗 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" title="新增"
               :visible.sync="postObj" width="30%" :before-close="handleCancel">
      <el-form :model="addForm" ref="addForm" :rules="rules" label-width="80px">
        <el-form-item label="CAS" prop="cas_nos">
          <el-input type="textarea" rows="10" v-model="addForm.cas_nos"
                    :placeholder="`请输入CAS号，一行一个CAS NO. 例如：\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6\n808118-40-3\n1051375-16-6`"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">

        <el-button type="primary" plain @click="addGoods">联系客服添加未有产品</el-button>
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 投诉建议 -->
    <add-complaint :dialogFormVisible="dialogFormVisiblecomplaint" @close="dialogFormVisiblecomplaint = false"
                   @success="successFun"/>
    <!-- 快递信息弹窗 -->
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        title="快递信息"
        :visible.sync="expressDialogVisible"
        width="50%"
    >
      <div>
        <el-timeline :reverse="true">
          <el-timeline-item
              v-for="(item,index) in expressList"
              :key="index"
              :timestamp="item.time"
              placement="top"
          >
            <div>
              <p>{{ item.context }}</p>
            </div>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-if="expressList.length==0" description="还没有物流信息哦~"/>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="expressDialogVisible = false">关闭</el-button>
  </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  productAdd,
  supplier_order_list,
  delivery,
  apply_contract,
  purchase_order_detail,
  getMyCustomerService
} from "@/api/modules/user";
import GradientButton from "@/components/button/gradient-button.vue";
import addComplaint from "@/components/addInfo/add_complaint.vue";
import {mapGetters} from "vuex";
import {express} from "../../../api/modules/home";
import Empty from "../../../components/public/empty.vue";

export default {
  name: "order",

  components: {
    Empty,
    GradientButton,
    addComplaint
  },
  data() {
    return {
      dialogFormVisiblecomplaint: false,
      //联系客服
      dialogVisiblecos: false,
      dialogContent: '',
      loading: false,
      linkPath: this.$api.linkPath,
      dialogVisible: false,
      // 点击查看详情
      detailDialogVisible: false,
      // 订单详情
      detail: {},
      form: {
        cas_no: "",
        created_at: [],
        orderno: '',
      },
      // 发货表单
      deliveryForm: {
        express_order: "",
        express_company: "",
      },
      deliveryFormRules: {
        express_order: [
          {required: true, message: "请输入发货单号", trigger: "blur"},
        ],
        express_company: [
          {required: true, message: "请输入快递公司", trigger: "blur"},
        ],
      },
      activeTarBar: "0",
      terbars: [
        {
          label: "全部",
          value: "0",
        },
        {
          label: "待发货",
          value: "1",
        },
        {
          label: "待收货",
          value: "2",
        },
        {
          label: "交易完成",
          value: "3",
        },
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      selectRow: {},
      //新增产品弹窗
      postObj: false,
      addForm: {
        cas_nos: "",
      },
      rules: {
        cas_nos: [{required: true, message: "请输入CAS号", trigger: "blur"}],
      },
      expressList: [],
      expressDialogVisible: false
    };
  },
  mounted() {
    this.page = 1;
    this.getList();
  },
  computed: {
    ...mapGetters(["is_vip", "userInfo"]),
  },
  methods: {
    doLook(link) {
      window.open(link, '_blank')
    },
    // 点击查看快递弹窗
    viewExpressInfo() {
      express(this.detail.id).then(res => {
        if (res.data.data) {
          this.expressList = res.data.data;
          this.expressDialogVisible = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    successFun() {
      this.dialogFormVisiblecomplaint = false
    },
    addGoods() {
      this.addForm.cas_nos = ''
      this.dialogFormVisiblecomplaint = true
    },
    // 复制文本
    copyText(text) {
      this.$utils.copyText(text, this);
    },

    // 联系客服
    handleGuarantee() {

      getMyCustomerService().then(res => {
        this.dialogContent = res.data.data.mobile
        this.dialogVisiblecos = true;
      })
    },
    // 关闭详情
    handleCloseDetail() {
      this.detailDialogVisible = false;
    },
    // 查看
    handleDetail(row) {
      purchase_order_detail(row.id).then((res) => {
        this.detail = res.data.data;
        this.detailDialogVisible = true;
      });
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.form = {
        cas_no: "",
        orderno: '',
        created_at: [],
      };
      this.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      supplier_order_list({
        page: this.page,
        limit: this.pageSize,
        state: this.activeTarBar,
        cas_no: this.form.cas_no,
        orderno: this.form.orderno,
        created_at: this.form.created_at,
      }).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    // 申请合同
    handleContract(row) {
      apply_contract(row.id, {
        contract_id: row.id,
      }).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
          this.getList();
        } else {
          this.$message.error({
            message: res.data.message,
            duration: 2000,
            offset: 200,
          });
        }
      });

    },
    // 提交发货
    submitDelivery() {
      this.$refs.deliveryForm.validate((valid) => {
        if (valid) {
          delivery(this.selectRow.id, this.deliveryForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 去发货
    handleDelivery(row) {

      this.$router.push({
        path: "/operate/sendGoods",
        query: {
          order_id: row.id,
        },
      });

    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },

    handleTarBar(value) {
      this.activeTarBar = value;
      this.page = 1;
      this.getList();
    },
    // 新增产品弹窗打开
    handleAdd() {
      if (this.mixCheckUserAudit()) {
        this.postObj = true;
      }
    },
    // 新增产品弹窗关闭
    handleCancel() {
      this.postObj = false;
      this.addForm.cas_nos = ''
    },
    // 发布产品
    handleConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          productAdd(this.addForm).then((res) => {
            if (res.data.code == 10000) {
              this.postObj = false;
              this.addForm.cas_nos = ''
              this.$alert(res.data.message, '发布结果', {
                confirmButtonText: '确定',
              });
            } else {
              this.$message.error({
                message: res.data.message,
                type: "error",
                duration: 2000,
                offset: 100,
              });
            }
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.image-pay {
  width: 300px;
  height: auto;
  object-fit: contain;
}

::v-deep .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 15vw;
}

.padding-top-10 {
  padding-top: 10px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  /* 关键：合并边框 */
  border-color: #f3f3f3;

  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3) {
    padding: 10px 20px;
    white-space: nowrap;
    background: #f9faff;
    text-align: right;
    color: #5f616c;
  }

  td:nth-child(2),
  td:nth-child(4) {
    padding: 10px 20px;
    padding-left: 33px;
    border: 1px solid #f3f3f3;
    color: #00112b;
  }
}

.color-blue {
  color: #2979f1;
  text-decoration: none;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

.content {
  padding: 0 0 20px;

  .fotter-box {
    // height: 635px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;

    .pagination-box {
      padding: 20px;

      .float-right {
        float: right;
      }
    }
  }

  .top-box {
    // height: 220px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 30px 0;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    .search-btn {
      width: 120px;
      // height: 50px;
      background: #1890ff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2979f1;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      // line-height: 50px;
    }

    .reset-btn {
      width: 120px;
      // height: 50px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
      // line-height: 50px;
      text-align: center;
    }
  }

  .ter-bars {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .left-title {
      line-height: 28px;
      display: flex;
      align-items: center;
      gap: 50px;

      .ter-bar-item {
        font-weight: 400;
        font-size: 18px;
        color: #5f616c;
        border-bottom: 4px solid transparent;
      }

      .active {
        font-weight: bold;
        font-size: 18px;
        color: #00112b;
        border-bottom: 4px solid #1890ff;
      }
    }
  }
}
</style>
